



































import { Prop, VModel, Vue } from "vue-property-decorator";
import Component from "vue-class-component";

@Component
export default class UploadProgressSheet extends Vue {
  @Prop() uploadInfoProp;
  @VModel() openBottomSheet!: boolean;

  uploadInfos = [];

  aggregate() {
    this.uploadInfos = Object.values(this.uploadInfoProp).flatMap(e => e);
    this.openBottomSheet = true;
  }
}
